module.exports = __webpack_public_path__ + "static/how-it-works-step-4-ce15864caf5acaca21b247f772a63b0f.png";